import { amplitudeEventFactory } from "./amplitudeEventFactory";
import { gaEventFactory } from "./gaEventFactory";

interface EventParams {
  action: string;
  label?: string;
  value?: number;
}

export interface TrackersFactory {
  (params: EventParams): void;
}

export const trackersFactory = (category: string): TrackersFactory => {
  const ga = gaEventFactory(category);
  const amp = amplitudeEventFactory(category);

  return (params: EventParams): void => {
    ga(params);
    amp(params);
  };
};
